/** Teksty nagłówków widoków (Hero 2.0): grupa sales. Klucze: heroSales.* */
export const heroSalesPl = {
  customers: {
    total: 'Klienci w bazie',
    totalHint: 'wg bieżących filtrów (bez statusu)',
    active: 'Aktywni',
    activeHint: '{pct} bazy',
    toContact: 'Do kontaktu',
    toContactHint: 'kliknij, aby przefiltrować',
    atRisk: 'Nieaktywni i utraceni',
    atRiskHint: 'utraceni {lost} · nieaktywni {inactive}',
    insightToContact: 'Klienci czekający na kontakt: {count}. Odezwij się, zanim zrobi to konkurencja.',
    insightAtRisk: 'Nieaktywni i utraceni stanowią {pct} bazy ({count}). Warto sprawdzić, kogo da się odzyskać.',
    insightHealthy: 'Baza w dobrej kondycji: {pct} klientów jest aktywnych.',
    insightEmpty: 'Brak klientów dla wybranych filtrów.',
    seeToContact: 'Pokaż do kontaktu',
    seeAtRisk: 'Pokaż utraconych',
    actions: { newCustomer: 'Nowy klient', toContact: 'Do kontaktu', map: 'Mapa klientów', list: 'Lista klientów', alerts: 'Alerty' },
  },
  customer: {
    sales12m: 'Sprzedaż 12 mies.',
    sales12mHint: '{orders} zamówień · śr. {avg}',
    salesMtd: 'Ten miesiąc',
    salesMtdHint: 'poprzedni mies.: {prev}',
    salesMtdHintLastOrder: 'ostatnie zamówienie: {when}',
    vsPrev: 'vs ten sam okres poprz. mies.',
    margin: 'Marża 12 mies.',
    marginHint: '{amount} zysku',
    overdue: 'Należności po terminie',
    overdueHint: '{count} dok. po terminie · razem do zapłaty {total}',
    overdueNone: 'brak zaległości · do zapłaty {total}',
    lastOrder: 'Ostatnie zamówienie',
    lastOrderNone: 'brak zamówień',
    lastOrderHint: '{number} · {net}',
    insightOverdue: 'Po terminie jest {amount}. Ustal z klientem termin płatności, zanim przyjmiesz kolejne zamówienie.',
    insightAlerts: 'Otwarte alerty dla tego klienta: {count}. Sprawdź, co wymaga reakcji.',
    insightContactOverdue: 'Zaplanowany kontakt jest zaległy od {days}. Zadzwoń lub umów wizytę.',
    insightDeclining: 'Sprzedaż w tym miesiącu jest niższa o {pct} niż w tym samym okresie poprzedniego. Sprawdź, czego klient przestał kupować.',
    insightNoOrder: 'Brak zamówienia od {days}. Skontaktuj się z klientem i zapytaj o potrzeby.',
    insightGrowing: 'Klient rośnie: sprzedaż w tym miesiącu wyższa o {pct} niż w tym samym okresie poprzedniego miesiąca. Dobry moment na cross-sell.',
    insightDefault: 'Bez niepokojących sygnałów. Ostatni kontakt: {contact}.',
    noContact: 'brak zapisanych kontaktów',
    seeDocuments: 'Dokumenty',
    seeAlerts: 'Alerty',
    seeVisits: 'Wizyty',
    seeProducts: 'Produkty',
    seeSales: 'Sprzedaż',
    actions: { call: 'Zadzwoń', email: 'Napisz e-mail', products: 'Co kupuje', documents: 'Dokumenty', visits: 'Historia wizyt' },
  },
  leads: {
    pipeline: 'Wartość lejka',
    pipelineHint: 'potencjał mies. · oferta i akceptacja: {late}',
    open: 'Otwarte leady',
    openHint: 'w tym nowych: {fresh}',
    conversion: 'Konwersja (12 mies.)',
    conversionHint: 'wygrane / (wygrane + przegrane)',
    stale: 'Zastałe leady',
    staleHint: 'w jednym etapie ponad {days} dni',
    insightStale: 'Leady stojące w etapie zbyt długo: {count} (potencjał {amount}). Wróć do nich, zanim ostygną.',
    insightLate: 'W ofercie i akceptacji czeka {amount} potencjału (leady: {count}). Domknij te rozmowy w pierwszej kolejności.',
    insightEmpty: 'Lejek jest pusty. Dodaj pierwszy lead i zacznij budować pipeline.',
    insightDefault: 'Lejek w ruchu, brak zastałych leadów. Zadbaj o regularny dopływ nowych kontaktów.',
    openOldest: 'Otwórz najstarszy',
    addLead: 'Dodaj lead',
    actions: { newLead: 'Nowy lead', tasks: 'Moje zadania', customers: 'Klienci', list: 'Widok listy', board: 'Widok tablicy' },
  },
};

export const heroSalesEn: typeof heroSalesPl = {
  customers: {
    total: 'Customers',
    totalHint: 'under current filters (any status)',
    active: 'Active',
    activeHint: '{pct} of the base',
    toContact: 'To contact',
    toContactHint: 'click to filter',
    atRisk: 'Inactive and lost',
    atRiskHint: 'lost {lost} · inactive {inactive}',
    insightToContact: 'Customers waiting for contact: {count}. Reach out before the competition does.',
    insightAtRisk: 'Inactive and lost customers make up {pct} of the base ({count}). Worth checking who can be won back.',
    insightHealthy: 'The base is in good shape: {pct} of customers are active.',
    insightEmpty: 'No customers match the selected filters.',
    seeToContact: 'Show to-contact',
    seeAtRisk: 'Show lost',
    actions: { newCustomer: 'New customer', toContact: 'To contact', map: 'Customer map', list: 'Customer list', alerts: 'Alerts' },
  },
  customer: {
    sales12m: 'Sales, 12 months',
    sales12mHint: '{orders} orders · avg {avg}',
    salesMtd: 'This month',
    salesMtdHint: 'last month: {prev}',
    salesMtdHintLastOrder: 'last order: {when}',
    vsPrev: 'vs same period last month',
    margin: 'Margin, 12 months',
    marginHint: '{amount} profit',
    overdue: 'Overdue receivables',
    overdueHint: '{count} overdue docs · {total} outstanding in total',
    overdueNone: 'nothing overdue · {total} outstanding',
    lastOrder: 'Last order',
    lastOrderNone: 'no orders',
    lastOrderHint: '{number} · {net}',
    insightOverdue: '{amount} is overdue. Agree a payment date with the customer before taking the next order.',
    insightAlerts: 'Open alerts for this customer: {count}. Check what needs a reaction.',
    insightContactOverdue: 'The planned contact is overdue by {days}. Call or book a visit.',
    insightDeclining: 'Sales this month are {pct} lower than in the same period of last month. Check what the customer stopped buying.',
    insightNoOrder: 'No order for {days}. Get in touch and ask about their needs.',
    insightGrowing: 'The customer is growing: sales this month are {pct} higher than in the same period of last month. A good moment for cross-sell.',
    insightDefault: 'No worrying signals. Last contact: {contact}.',
    noContact: 'no contact recorded',
    seeDocuments: 'Documents',
    seeAlerts: 'Alerts',
    seeVisits: 'Visits',
    seeProducts: 'Products',
    seeSales: 'Sales',
    actions: { call: 'Call', email: 'Send e-mail', products: 'What they buy', documents: 'Documents', visits: 'Visit history' },
  },
  leads: {
    pipeline: 'Pipeline value',
    pipelineHint: 'monthly potential · offer and approval: {late}',
    open: 'Open leads',
    openHint: 'of which new: {fresh}',
    conversion: 'Conversion (12 mo.)',
    conversionHint: 'won / (won + lost)',
    stale: 'Stale leads',
    staleHint: 'in one stage for over {days} days',
    insightStale: 'Leads sitting in a stage for too long: {count} (potential {amount}). Revisit them before they go cold.',
    insightLate: '{amount} of potential is waiting in offer and approval (leads: {count}). Close these conversations first.',
    insightEmpty: 'The pipeline is empty. Add the first lead and start building it.',
    insightDefault: 'The pipeline is moving and nothing is stale. Keep a steady flow of new contacts.',
    openOldest: 'Open the oldest',
    addLead: 'Add lead',
    actions: { newLead: 'New lead', tasks: 'My tasks', customers: 'Customers', list: 'List view', board: 'Board view' },
  },
};
